/*
 * Copyright (C) 2021 Bosch.IO GmbH. All rights reserved.
 */

let idGen = 0;
export function getId(): string {
    const result = idGen++;
    return result.toString();
}
